var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldBluetooth2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.61 15.39 12.3 13.3v4.02l2.31-1.93zM12.3 10.64l2.31-2.12-2.31-1.84v3.96z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm-1.18 8.62c.76 0 1.37.62 1.37 1.38a1.374 1.374 0 1 1-2.75 0c0-.76.62-1.38 1.38-1.38zm6.53 7.93c-.41.35-.79.45-1.08.45-.23 0-.41-.06-.51-.11-.23-.11-.77-.46-.77-1.44v-3.39l-2.9 2.65c-.3.28-.78.26-1.06-.05a.746.746 0 0 1 .05-1.06l3.91-3.58v-.08L6.89 8.4a.746.746 0 0 1-.05-1.06c.28-.3.76-.33 1.06-.05l2.9 2.65V6.56c0-.98.54-1.34.77-1.44.23-.11.85-.29 1.6.34l2.41 2.01c.33.27.52.66.53 1.07.01.41-.16.81-.47 1.1L13.04 12l2.59 2.37c.31.29.49.69.48 1.1-.02.41-.21.8-.54 1.07l-2.41 2.01zM16 12c0-.76.62-1.38 1.38-1.38.76 0 1.38.62 1.38 1.38 0 .76-.63 1.38-1.38 1.38-.76 0-1.38-.62-1.38-1.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBluetooth2);
export default __webpack_public_path__ + "static/media/vuesax-bold-bluetooth-2.0fc1ee91500f9130deba734b347ff127.svg";
export { ForwardRef as ReactComponent };